import { Modal } from "@mui/material";
import CustomerMaster from ".";

const CustomerModal = ({ handleClose, status, afterCreate }) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    height: "80%",
    width: "auto",
    borderRadius: "8px",
    overflow: "hidden",
    backgroundColor: "white",
  };

  return (
    <>
      <Modal open={status}>
        <div style={style}>
          <CustomerMaster onClose={handleClose} afterCreate={afterCreate} />
        </div>
      </Modal>
    </>
  );
};

export default CustomerModal;
